module.exports = __webpack_public_path__ + "static/capital-91cb2c246b798080295fd93e70778936.svg";